export default "__VITE_ASSET__275c702f__"